import React, { useEffect, useState } from "react";
import Catalogue from "./Catalogue";
import ModalComponent from "components/UI/MaterialUIComponents/ModalComponent";
import { useHistory } from "react-router-dom";
import StepperAddOrEditForm from "components/UI/StepperForm/StepperAddOrEditForm";
import { AddMaterialIcon } from "Icons/MaterialIcons";
import "./EditCatalogue.scss";
import { detectTouchScreen } from "Functions/functions";

const EditCatalogue = () => {
	const history = useHistory();
	const [items, setItems] = useState([]);
	const [stateModal, setStateModal] = useState(true);
	const [touchScreen, setTouchScreen] = useState();
	const handleClose = () => setStateModal(false);

	if (
		window.localStorage.getItem("account") === "false" ||
		window.localStorage.getItem("account") === false
	) {
		history.push("/ingresar");
	}

	useEffect(() => {
		detectTouchScreen(setTouchScreen)
	}, [])

	return (
		<section className="editCatalogue">
			<ModalComponent
				stateModal={stateModal}
				scrollable={true}
				setStateModal={setStateModal}
				slotOpenModal={
					<span className={touchScreen ? "floatBtn touchScreen" : "floatBtn"}>
						<AddMaterialIcon className="floatBtn__addIcon" />
						<span className="floatIcon__textSpan">
							<span>Agregar Producto</span>
						</span>
					</span>
				}
			>
				{
					<StepperAddOrEditForm
						setItems={setItems}
						items={items}
						handleClose={handleClose}
						type="add"
						steps={["Marca", "Modelo", "Tipo", "Numeración", "Imagenes", "Precio"]}
					/>
				}
			</ModalComponent>
			<Catalogue edit={true} setItems={setItems} newItems={items} />
		</section>
	);
};

export default EditCatalogue;
